<script>
import { debounce } from 'lodash'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
export default {
  name: 'customerControl',
  props: ['value'],
  data() {
    return {
      model: {},
      fetch_customer: false,
      showModalCreate: false,
      loading: false,
      errors: new Errors(),
      customerModel: {
        customer_id: 0,
        cus_type_id: 2, // for sale lok dom
        customer_name: null,
        gender: null,
        contact_number: null,
        contact_email: null,
        facebook_account: null,
        telegram: null,
        city_province: null,
        year_of_born: null,
        account_number: null,
        is_general_customer: false,
        is_membership: false,
        is_allow_update_gps_location: false,
        membership_discount_rate: 0,
        company_name: null,
        zip_code: null,
        credit_day: 0,
        credit_amount: 0,
        province_code: null,
        disctrict_code: null,
        commune_code: null,
        village_code: null,
        sale_id: null,
        ss_id_card: null,
        contact_number2: null,
        approve_status: 2 // set default to approve
      }
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('saleInvoiceStore', ['customers']),
    customerList() {
      return this.customers.map(el => ({
        value: el.customer_id,
        label: el.customer_name,
        credit_amount: el.credit_amount,
        contact_number: el.contact_number,
        credit_day: el.credit_day,
        employee_id: el.employee_id
      }))
    }
  },
  methods: {
    ...mapActions('saleInvoiceStore', ['onGetCustomer', 'onGetSale']),
    searchCustomer: debounce(async function(query) {
      var avoidSearch = this.customerList.find(
        c => c.label + '-' + c.contact_number == query.trim()
      )
      if (avoidSearch) return
      this.onGetCustomer(query)
    }, 500),
    handleCustomerSearch: debounce(function(search_customer) {
      this.fetch_customer = true
      this.onGetCustomer({
        params: {
          search_customer
        }
      }).finally(() => (this.fetch_customer = false))
    }, 500),
    onCustomerChange(value, opt) {
      this.model.credit_day = opt.data.attrs.opt.credit_day
      this.creditDayChange()
      this.model.seller_id = opt.data.attrs.opt.employee_id
      this.onGetSale(opt.data.attrs.opt.employee_id)
    },
    creditDayChange() {
      if (this.model.amount_due > 0) {
        this.updateNextPaymentDate()
      }
    },
    updateNextPaymentDate() {
      if (this.model.stock_out_date && this.model.amount_due > 0) {
        this.model.next_payment_date = moment(
          this.model.stock_out_date,
          'DD-MM-YYYY'
        )
          .add(this.model.credit_day, 'days')
          .format('DD-MM-YYYY')
      }
    },
    onShowModal() {
      this.showModalCreate = true
    },
    onSave() {
      this.loading = true
      this.errors = new Errors()
      this.$store
        .dispatch('customer/profile/store', this.customerModel)
        .then(response => {
          this.$toasted.success(response.message)
          this.$store.commit(
            'saleInvoiceStore/PUSH_NEW_CUSTOMER',
            response.data
          )
          this.model.customer_id = response.data.customer_id
          this.showModalCreate = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<template>
  <div>
    <div class="ts-flex ts-justify-between">
      <label class="required ts-mb-0">{{ $t('saleInvoice.customer') }}</label>
    </div>
    <div class="ts-flex ts-space-x-2">
      <a-select
        show-search
        v-model="model.customer_id"
        style="width: 100%"
        :default-active-first-option="false"
        :show-arrow="false"
        :filter-option="false"
        :not-found-content="null"
        :loading="fetch_customer"
        @search="handleCustomerSearch"
        @change="onCustomerChange"
        filterable
      >
        <a-select-option
          v-for="c in customerList"
          :key="c.value"
          :value="c.value"
          :opt="c"
        >
          {{ c.label + (c.contact_number ? ' ' + c.contact_number : '') }}
        </a-select-option>
      </a-select>
      <button @click.prevent="onShowModal" class="ts-border ts-px-2 ts-rounded">
        <i class="fas fa-user-plus"></i>
      </button>
    </div>

    <a-modal
      v-model="showModalCreate"
      :title="$t('saleInvoice.createCustomer')"
      :footer="null"
      centered
    >
      <ts-loading-banner :loading="loading">
        <div class="row ts-space-y-2">
          <div class="col-md-12">
            <label class="ts-text-xs required">{{
              $t('customerProfile.customerName')
            }}</label>
            <input
              v-model="customerModel.customer_name"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('customer_name') }"
            />
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('customer_name')"
            >
              {{ errors.first('customer_name') }}
            </div>
          </div>
          <div class="col-md-12">
            <div class="ts-w-full">
              <a-radio-group v-model="customerModel.gender" class="ts-p-3">
                <a-radio value="Male">Male</a-radio>
                <a-radio value="Female">Female</a-radio>
                <a-radio value="Other">Other</a-radio>
              </a-radio-group>
            </div>
            <div class="validate ts-text-xs" v-if="errors.has('gender')">
              {{ errors.first('gender') }}
            </div>
          </div>
          <div class="col-md-12">
            <label class="ts-text-xs">{{ $t('customerProfile.idCard') }}</label>
            <input
              v-model.trim="customerModel.ss_id_card"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('ss_id_card') }"
            />
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('ss_id_card')"
            >
              {{ errors.first('ss_id_card') }}
            </div>
          </div>
          <div class="col-md-6">
            <label class="ts-text-xs required">{{
              $t('customerProfile.phoneNumber')
            }}</label>
            <input
              v-model.trim="customerModel.contact_number"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('contact_number') }"
            />
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('contact_number')"
            >
              {{ errors.first('contact_number') }}
            </div>
          </div>
          <div class="col-md-6">
            <label class="ts-text-xs">{{
              $t('customerProfile.phoneNumber2')
            }}</label>
            <input
              v-model="customerModel.contact_number2"
              type="text"
              class="form-control"
            />
          </div>
          <div class="col-md-6">
            <label class="form-label ts-text-xs">{{
              $t('customerProfile.telegram')
            }}</label>
            <input
              v-model="customerModel.telegram"
              type="text"
              class="form-control"
            />
          </div>
          <div class="col-md-6">
            <label class="form-label ts-text-xs">{{
              $t('customerProfile.facebook')
            }}</label>
            <input
              v-model="customerModel.facebook_account"
              type="text"
              class="form-control"
            />
          </div>
          <div class="col-md-12 ">
            <div class="ts-flex ts-justify-end ts-mt-3">
              <ts-button
                class="mr-2"
                @click.prevent="() => (showModalCreate = false)"
              >
                {{ $t('cancel') }}
              </ts-button>
              <ts-button
                color="primary"
                @click.prevent="onSave"
                :waiting="loading"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </div>
        </div>
      </ts-loading-banner>
    </a-modal>
  </div>
</template>
